module.exports = __webpack_public_path__ + "img/head.16516a9f.png";